import React from 'react';
import ReactECharts from 'echarts-for-react';
import * as styles from './year-in-position-tenure-insights-chart.module.scss';
import PropTypes from 'prop-types';

const YearInPositionTenureInsightsChart = ({ data, onViewReport, hoveredValueRef }) => {
  const categories = data?.map((d) => d.name);
  const legends = data?.[0] ? Object.keys(data[0]).filter((key) => key !== 'name') : [];

  const option = {
    textStyle: {
      fontFamily: 'Inter',
    },
    color: ['#00A19C', '#8B58B1', '#31A5F5', '#337CA0'],
    tooltip: {
      show: false,
    },
    legend: {
      data: legends,
      selectedMode: false,
      top: 15,
      left: 20,
      itemWidth: 18,
      itemHeight: 18,
      itemGap: 20,
      textStyle: {
        fontSize: 14,
        color: '#3F3C4C',
        fontWeight: 600,
      },
    },
    grid: {
      top: 60,
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        data: categories,
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: {
          fontSize: 12,
          fontWeight: 400,
          color: '#394655',
          margin: 15,
          backgroundColor: '#F0F5FA',
          padding: [4, 8],
          borderRadius: 6,
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          fontSize: 14,
          fontWeight: 400,
          color: '#4F5F6E',
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
            color: '#e5e7eb',
          },
        },
      },
    ],
    series: legends.map((key) => ({
      name: key,
      type: 'bar',
      stack: 'total',
      barWidth: '35%',
      label: {
        show: true,
        position: 'inside',
        fontWeight: '700',
        color: '#FFFFFF',
        fontSize: 12,
        formatter: (params) => (params.value === 0 ? '' : params.value),
      },
      barCategoryGap: '50',
      data: data?.map((d) => ({
        value: d[key],
        itemStyle: {
          borderRadius: 4,
          borderColor: '#fff',
          borderWidth: d[key] === 0 ? 0 : 2,
        },
      })),
    })),
  };
  const onEvents = {
    mouseover: (params) => {
      if (params?.name != null && params?.seriesName != null) {
        hoveredValueRef.current = {
          xAxisName: params.name,
          stackName: params.seriesName,
        };
      }
    },
  };
  return (
    <div className={styles.wrapper}>
      <ReactECharts option={option} style={{ height: 600 }} onEvents={onEvents}/>
      <button className={styles.btn} onClick={() => onViewReport(hoveredValueRef.current)}>View report</button>
    </div>
  );
};

export default YearInPositionTenureInsightsChart;

YearInPositionTenureInsightsChart.propTypes = {
  data: PropTypes.array,
  onViewReport: PropTypes.func,
};
